import styled from '@emotion/styled';
import xw from 'xwind';

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 59px 12px 20px 12px;
  justify-content: space-between;

  @media (max-width: 640px) {
    font-size: 12px;
    padding: 28px 0 0 0;
  }
`;

export const Content = styled.p`
  font-size: 12px;
  overflow: hidden;
  line-height: 14px;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;

  @media (min-width: 640px) {
    font-size: 20px;
    line-height: 22px;
  }
`;

export const AuthorContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const AuthorName = styled.p`
  ${xw('text-primary')}

  font-size: 16px;
  overflow: hidden;
  margin-left: 21px;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media (max-width: 640px) {
    font-size: 12px;
    margin-left: 10px;
  }
`;
